<template>
    <div>
        <el-dialog :title="type==1?'解约':'流失'+'原因'" :visible.sync="lostVisible" width="600px" center :close-on-click-modal="false" class="refuse-dialog">
            <!-- <div>请输入流失原因</div>
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="lossCause"></el-input> -->
            <el-form ref="refuseOnlineForm" :rules="refuseRules" :model="refuseOnlineForm">
                <el-form-item v-if="subType==5" label="流失类型" >
                    <el-select  v-model="chooseSubType" clearable placeholder="请选择流失类型" filterable>
                        <el-option v-for="(item, index) in workerSubState" :key="index" :label="item" :value="index + ''">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="type==1?'解约':'流失'+'原因'" prop="levelOne">
                    <el-cascader style="width:100%;" v-model="refuseOnlineForm.levelOne" filterable placeholder="请选择原因" @change="levelOneChange" :options="levelOneList" :props="optionProps">

                    </el-cascader>

                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="lostVisible = false">取 消</el-button>
                <el-button type="primary" @click="comfirmLostBtn('refuseOnlineForm')">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import workercrmapi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
let vm;
export default {
    data() {
        return {
            workerSubState:{
                1:'背调失败',2:'培训淘汰',3:'拒绝入职',4:'入职审批拒绝'
            },
            type:null,//操作类型： type 1解约原因，2流失原因
            subType:null,//线索4跟进失败  服务者5上线失败
            chooseSubType:'',
            levelOneList: [],
            optionProps: {
                value: "type",
                label: "typeValue",
                children: "childList",
                multiple: true,
                //  checkStrictly: true
            },
            lostVisible: false,
            tempRow: {},
            refuseOnlineForm: {
                levelOne: [],
            },
            refuseRules: {
                levelOne: [
                    {
                        required: true,
                        message: "请选择原因",
                        trigger: "change",
                    },
                ],
            },
        };
    },
    beforeCreate() {
        vm = this;
    },
    methods: {
        leaveLossClick(row,type,subType) {
            // type 1解约原因，2流失原因
            this.lostVisible = true;
            this.tempRow = row;
            this.type=type;
            this.subType=subType;

            this.refuseOnlineForm.levelOne = [];


            workercrmapi
                .$axiosgetLossleaveDict({
                    type: type
                })
                .then((res) => {
                    console.log(res);
                    this.levelOneList = res.data.data;
                });
        },
        levelOneChange(value) {
            console.log(value);
        },
        comfirmLostBtn(formName) {
            if(this.subType==5&&this.chooseSubType==''){
                this.$message.error("请选择流失类型");
                return;
            }

            this.$refs[formName].validate((valid) => {
                if (valid) {

                    let operType=this.type==1?3:5; //操作类型operType：3解约， 5流失
                    workercrmapi
                        .$axiosleaveOrLossOrReinstated({
                            workerNo: this.tempRow.workerNo,
                            operType:operType,
                            subType:this.subType,
                            chooseSubType:this.chooseSubType,
                            parseObject: this.refuseOnlineForm.levelOne,
                            operUserId: globalData.userInfo.id,
                            operUserName: globalData.userInfo.userName,
                        })
                        .then((res) => {
                            this.lostVisible = false;
                            // this.setTabType(this.tabType).splice(this.row, 1);
                            this.$message.success("成功");
                             this.$parent.querySearch();
                            console.log(res);
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                } else {
                    console.log("err");
                }
            });
        },
    },
};
</script>
<style>
</style>
